export default function Footer()
{
  return(
  <footer className='center'>
    <small>© FCTL</small>
  </footer>
  )
}